import { reads } from '@ember/object/computed';
import Em from 'ember';
export default Em.Component.extend({
  classNames: ['text-editor', 'popup-inserter-cell', 'o__flexes-to-1', 'o__has-columns'],
  updatedValue: reads('value')
});